import config from 'services/table/const';
import Action from './action';
import ItemsStatus from './status';
import { currencyFormat } from 'utilities/common';

let table = { ...config };
table.url = '/wms/item';
table.columns = {
  code: {
    title: 'Kode',
    sortable: true,
    alias: 'code',
    width: 80,
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fs-8 fw-semibold">{row?.code}</div>
          {
            row?.barcode && (
              <small className="text-ellipsis info">
                Barcode: {row?.barcode || '-'}
              </small>
            )
          }
        </div>
      );
    },
  },

  customer: {
    title: 'Customer',
    width: 100,
    component: (row) => {
      return <div className="text-ellipsis">{row?.tenant?.name}</div>;
    },
  },

  name: {
    title: 'Nama Item',
    sortable: true,
    alias: 'name',
    width: 150,
    component: (row) => {
      return <div className="text-ellipsis">{row?.alias_name || '-'}</div>;
    },
  },

  category: {
    title: 'Kategori',
    sortable: true,
    alias: 'category',
    width: 80,
    component: (row) => {
      return <div className="text-ellipsis">{row?.category}</div>;
    },
  },

  default_fraction: {
    title: 'Default Fraction',
    sortable: false,
    alias: 'default_fraction',
    width: 80,
    component: (row) => {
      return <div>{row?.default_fraction}</div>;
    },
  },

  weight: {
    title: 'Berat (Gram)',
    format_number: true,
    sortable: false,
    alias: 'weight',
    width: 80,
    class: 'text-end',
    classHeader: 'text-end',
  },

  base_price: {
    title: 'Harga Dasar',
    format_number: true,
    sortable: false,
    alias: 'base_price',
    width: 80,
    class: 'text-end',
    classHeader: 'text-end',
  },

  margin: {
    title: 'Margin (%)',
    format_number: true,
    sortable: false,
    alias: 'margin',
    width: 80,
    class: 'text-end',
    classHeader: 'text-end',
  },

  stock_available: {
    title: 'Stock Tersedia',
    sortable: true,
    class: 'text-end',
    classHeader: 'text-center',
    width: 80,
    component: (row) => {
      return <div>{currencyFormat(row?.stock_available)}</div>;
    },
  },

  stock_defect: {
    title: 'Stock Rusak',
    sortable: true,
    class: 'text-end',
    classHeader: 'text-center',
    width: 80,
    component: (row) => {
      return <div>{currencyFormat(row?.stock_defect)}</div>;
    },
  },

  is_active: {
    title: 'Status',
    sortable: true,
    format_number: false,
    class: 'text-center',
    classHeader: 'text-center',
    width: 70,
    component: (row) => {
      return <ItemsStatus data={row} />;
    },
  },

  action: {
    title: '',
    sortable: false,
    width: 40,
    class: 'text-end',
    component: (row) => {
      return <Action data={row} />;
    },
  },
};

export default table;
